import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol, DecimalPipe, formatNumber } from '@angular/common';
import { isNumber } from 'util';

@Pipe({
    name: 'customdate',
})

export class CustomDatePipe implements PipeTransform {
    transform(
        value: string,
    ): string | null {
        let date = value.split('T');
        if(date.length && date[0] != '') {
          var date1 = date[0].split('-');
          if(date1.length == 3) {
            return date1[1] + '-' + date1[2] + '-' + date1[0];
          } else {
            return date[0];
          }
        }
        return value;
        
    }
}
